export class ExTranslation {
    id?: number;
    locale = 'fr';
    label = '';

    constructor(options = null) {
        if (options) {
            Object.assign(this, options);
        }
    }
}
